import { TakeoffItemComponent } from '@/app/types/takeoffs';
import { ApiClient } from './client';

export class TakeoffComponentClient extends ApiClient {
  /**
   * Get a specific component of a takeoff item
   * @throws {Error} If the API request fails
   */
  async getComponent(projectId: number, takeoffId: number, itemId: number, componentId: number) {
    return this._get<TakeoffItemComponent>(
      `projects/${projectId}/takeoffs/${takeoffId}/items/${itemId}/components/${componentId}/`,
    );
  }

  /**
   * Update a component of a takeoff item
   * @throws {Error} If the API request fails
   */
  async updateComponent(
    projectId: number,
    takeoffId: number,
    itemId: number,
    componentId: number,
    data: {
      name?: string;
      quantity?: string;
      price?: string;
      labor_hours?: string;
      reasoning?: string;
      confidence?: number;
      search_query?: string;
      component_type?: string;
      product_catalog_item_id?: number;
      material_unit_id?: number;
      quantity_ratio?: string;
      price_per_unit?: string;
      labor_hours_per_unit?: string;
      labor_price?: string;
      total_price?: string;
      is_manual_override?: boolean;
    },
  ) {
    return this._patch<TakeoffItemComponent>(
      `projects/${projectId}/takeoffs/${takeoffId}/items/${itemId}/components/${componentId}/`,
      data,
    );
  }

  /**
   * Create a new component for a takeoff item
   * @throws {Error} If the API request fails
   */
  async createComponent(
    projectId: number,
    takeoffId: number,
    itemId: number,
    data: {
      name: string;
      quantity: string;
      price: string;
      labor_hours: string;
      reasoning: string;
      confidence: number;
      search_query: string;
      component_type: string;
      product_catalog_item_id?: number;
      is_manual_override?: boolean;
    },
  ) {
    return this._post<TakeoffItemComponent>(
      `projects/${projectId}/takeoffs/${takeoffId}/items/${itemId}/components/`,
      data,
    );
  }

  /**
   * Delete a component of a takeoff item
   * @throws {Error} If the API request fails
   */
  async deleteComponent(projectId: number, takeoffId: number, itemId: number, componentId: number) {
    return this._delete(
      `projects/${projectId}/takeoffs/${takeoffId}/items/${itemId}/components/${componentId}/`,
    );
  }
}
